import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Page from '../../Components/Layout/Page';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { BaseSolarisCardWidth, StyledHeader } from '../../Utils/StyleUtils';
import { getOrganisationLink } from '../../Utils/NavigationUtils';
import OrganisationSwitcherResults from './OrganisationSwitcherResults';
import HeaderSearchBar from '../../Components/General/HeaderSearchBar';
import debounce from 'lodash-es/debounce';
import { Redirect, useHistory } from 'react-router-dom';
import { useOrganisationService } from '../../Services/OrganisationService';
import InlineSpinner from '@cb/solaris-react/Components/Loading/InlineSpinner';
import LoadingSpinner from '@cb/solaris-react/Components/Loading/LoadingSpinner';
const MAX_ORGS_SHOWN = 8;
export default function OrganisationsPage() {
    const [organisations, setOrganisations] = useState();
    const [error, setError] = useState();
    const [searchFilter, setSearchFilter] = useState();
    const history = useHistory();
    const organisationService = useOrganisationService();
    useEffect(() => {
        if (error) {
            return;
        }
        const { data } = organisationService.getOrganisations(MAX_ORGS_SHOWN, searchFilter ? searchFilter : undefined);
        data.then((organisations) => {
            setOrganisations(organisations);
        }).catch(() => {
            setError('Something went wrong fetching organisations, contact support if the issue persists.');
        });
    }, [organisationService, searchFilter, history, error]);
    // Search after atleast 250ms of typing
    const debouncedUpdateFilter = useMemo(() => debounce((name) => setSearchFilter(name), 250), []);
    const openOrg = async (orgId) => {
        await organisationService.saveOrganisationIdIntoLocalStorage(orgId);
        history.push(getOrganisationLink(orgId, ''));
    };
    if (organisations && organisations.orgs.length === 1 && searchFilter === undefined) {
        return _jsx(Redirect, { to: getOrganisationLink(organisations.orgs[0].id, '') });
    }
    // If we may select the first org automatically then don't load the full ui and instead just put a spinner (reduces jarring visual changes)
    if (organisations === undefined && !error) {
        return _jsx(LoadingSpinner, { overlay: true, text: "Loading organisation details" });
    }
    // TODO: Needs error state
    return (_jsx(Page, { pageTitle: "Organisations", hideSideMenu: true, children: _jsx(FullScreenContainer, { children: _jsxs(CenteredContainer, { children: [_jsxs(HeaderRow, { children: [_jsx(StyledHeader, { children: "Choose an organisation" }), _jsx(StyledSearchBar, { placeholder: 'Search organisations', onSearchChange: debouncedUpdateFilter })] }), organisations ? (_jsxs(_Fragment, { children: [_jsx(OrganisationSwitcherResults, { organisations: organisations, openOrg: openOrg }), _jsx(HeaderRow, { children: _jsx(OrgsCountText, { children: ` Showing ${organisations.orgs.length} of ${organisations.totalOrgs?.number} organisations.` }) })] })) : (_jsx(InlineSpinner, {}))] }) }) }));
}
const FullScreenContainer = styled.article `
	position: fixed;
	color: ${(props) => props.theme.secondary};
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	top: 0;
	left: 0;
	padding: ${(props) => props.theme.spacing.xl};
	background-color: ${(props) => props.theme.palette.primary};
	z-index: 4;
	overflow: auto;
	${(props) => props.theme.scrollbars.normal}
`;
const HeaderRow = styled.div `
	grid-column: 1 / -1;
	display: flex;
	flex-direction: column;
`;
const OrgsCountText = styled.p `
	text-align: center;
	font-size: ${(props) => props.theme.spacing.sm};
`;
const StyledSearchBar = styled(HeaderSearchBar) `
	margin-bottom: ${(props) => props.theme.spacing.sm};
`;
const CenteredContainer = styled.div `
	width: 100%;
	max-width: ${(props) => props.theme.breakpoints.lg};

	display: grid;
	align-items: center;
	justify-content: center;
	gap: ${(props) => props.theme.spacing.md};
	grid-template-columns: repeat(auto-fill, ${BaseSolarisCardWidth});

	@media (max-width: ${(props) => props.theme.breakpoints.xs}) {
		grid-template-columns: repeat(auto-fill, minmax(${BaseSolarisCardWidth}, 1fr));
	}
`;
//# sourceMappingURL=OrganisationsPage.js.map